/**
 * Decodes a JWT token and returns the payload.
 * This is a simple implementation that doesn't verify the signature.
 */
export function jwtDecode<T = Record<string, unknown>>(token: string): T {
	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		);
		return JSON.parse(jsonPayload);
	} catch (error) {
		console.error('Error decoding JWT:', error);
		return {} as T;
	}
}


